import React from 'react';
import { getTuneFormatMarker } from '../utils/tuneFormatMarker';
import './TuneFormatMarker.css';

/**
 * @param {{ item: object, variant?: 'corner' | 'inline', className?: string }} props
 */
export default function TuneFormatMarker({ item, variant = 'corner', className = '' }) {
  const marker = getTuneFormatMarker(item);
  if (!marker) return null;

  return (
    <span
      className={[
        'tune-format-marker',
        marker.className,
        `tune-format-marker--${variant}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      title={marker.title}
      aria-label={marker.title}
    >
      <span className="tune-format-marker-icons" aria-hidden="true">
        {marker.icons.map((icon, i) => (
          <React.Fragment key={`${icon}-${i}`}>
            {i > 0 && <span className="tune-format-marker-plus">+</span>}
            <span className="tune-format-marker-icon">{icon}</span>
          </React.Fragment>
        ))}
      </span>
      {marker.label ? (
        <span className="tune-format-marker-label">{marker.label}</span>
      ) : null}
    </span>
  );
}
